import moment from 'moment';
export default (date) => date ? moment(date).format('DD.MM.YYYY') : '-';



// WEBPACK FOOTER //
// ./resources/assets/js/FormatDate.js